import { render, staticRenderFns } from "./reply-follow.vue?vue&type=template&id=80419efe&scoped=true&"
import script from "./reply-follow.vue?vue&type=script&lang=js&"
export * from "./reply-follow.vue?vue&type=script&lang=js&"
import style0 from "./reply-follow.vue?vue&type=style&index=0&id=80419efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80419efe",
  null
  
)

export default component.exports